export default __webpack_public_path__ + "992232300a55820a6f6859ea7b6bf219.png";